/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardCctScreeningDto
 */
export interface DashboardCctScreeningDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardCctScreeningDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctScreeningDto
     */
    concerne?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctScreeningDto
     */
    nbJoursAre?: number;
    /**
     * 
     * @type {Date}
     * @memberof DashboardCctScreeningDto
     */
    dateAvertissementScreening?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DashboardCctScreeningDto
     */
    dateDecisionScreening?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardCctScreeningDto
     */
    masquee?: boolean;
}

/**
 * Check if a given object implements the DashboardCctScreeningDto interface.
 */
export function instanceOfDashboardCctScreeningDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardCctScreeningDtoFromJSON(json: any): DashboardCctScreeningDto {
    return DashboardCctScreeningDtoFromJSONTyped(json, false);
}

export function DashboardCctScreeningDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCctScreeningDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'concerne': !exists(json, 'concerne') ? undefined : json['concerne'],
        'nbJoursAre': !exists(json, 'nbJoursAre') ? undefined : json['nbJoursAre'],
        'dateAvertissementScreening': !exists(json, 'dateAvertissementScreening') ? undefined : (json['dateAvertissementScreening'] === null ? null : new Date(json['dateAvertissementScreening'])),
        'dateDecisionScreening': !exists(json, 'dateDecisionScreening') ? undefined : (json['dateDecisionScreening'] === null ? null : new Date(json['dateDecisionScreening'])),
        'masquee': !exists(json, 'masquee') ? undefined : json['masquee'],
    };
}

export function DashboardCctScreeningDtoToJSON(value?: DashboardCctScreeningDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'concerne': value.concerne,
        'nbJoursAre': value.nbJoursAre,
        'dateAvertissementScreening': value.dateAvertissementScreening === undefined ? undefined : (value.dateAvertissementScreening === null ? null : value.dateAvertissementScreening.toISOString()),
        'dateDecisionScreening': value.dateDecisionScreening === undefined ? undefined : (value.dateDecisionScreening === null ? null : value.dateDecisionScreening.toISOString()),
        'masquee': value.masquee,
    };
}

